import { Alert, AlertProps } from '@mui/material';
import { forwardRef } from 'react';
import { AlertIcon } from './alert-icons';

export type BasicAlertProps = AlertProps;

export const BasicAlert = forwardRef<HTMLDivElement, BasicAlertProps>(function (props, ref) {
  return (
    <Alert
      ref={ref}
      {...props}
      iconMapping={{
        error: <AlertIcon severity='error' />,
        success: <AlertIcon severity='success' />,
        warning: <AlertIcon severity='warning' />,
        info: <AlertIcon severity='info' />,
        // eslint-disable-next-line react/prop-types
        ...props.iconMapping,
      }}
    />
  );
});

BasicAlert.displayName = 'BasicAlert';
